import { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setCalendar } from '../../../../redux/calenderSlice'
import useCalendarDates from '../../hooks/useCalendarDates'

const InitialiseCalendar = () => {
    const dates = useCalendarDates()
    const dispatch = useDispatch()
    useEffect(() => {
        if (dates.data) {
            dispatch(setCalendar(dates.data))
        }
    }, [dates, dispatch])

    return null
}

export default memo(InitialiseCalendar)
